import apiClient from "./apiClient";

const quizServices = {
  getQuizzes: () => {
    return apiClient.get(`/quizzes`);
  },
  getQuizzesByID: (id) => {
    return apiClient.get(`/quizzes/${id}`);
  },
  createQuizzes: (payload) => {
    return apiClient.post(`/quizzes`, payload);
  },
  createQuestion: (payload) => {
    return apiClient.post(`/teacher-question-bank`, payload);
  },
  getSuggestedQuestionsBank: (id) => {
    return apiClient.get(`/questions-bank/${id}`);
  },
  getTeacherQuestionsBank: (id) => {
    return apiClient.get(`/teacher-question-bank/${id}`);
  },
  createQuestionForAlreadyCreatedAssessment: (id, payload) => {
    return apiClient.post(`/quizzes/add-questions/${id}`, payload);
  },
  deleteQuestion: (id) => {
    return apiClient.delete(`/teacher-question-bank/${id}`);
  },
  deleteQuestionFromAlreadyCreatedAssessment: (id) => {
    return apiClient.delete(`/quizzes/remove-question/${id}`);
  },
  editQuestion: (id, payload) => {
    return apiClient.post(
      `/teacher-question-bank/${id}`,
      { _method: "PUT", ...payload },
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
  getQuestionByID: (id) => {
    return apiClient.get(`/question-bank/${id}`);
  },
  addOption: (id, payload) => {
    return apiClient.post(`/teacher-question-bank-option/${id}`, payload);
  },
  editOption: (id, payload) => {
    return apiClient.post(
      `/teacher-question-bank-option/${id}`,
      { _method: "PUT", ...payload },
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
  deleteOption: (id) => {
    return apiClient.delete(`/teacher-question-bank-option/${id}`);
  },
};

export default quizServices;
